(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/components/tur/navigation-back/assets/javascripts/navigation-back.js') >= 0) return;  svs.modules.push('/components/tur/navigation-back/assets/javascripts/navigation-back.js');
"use strict";


const Icon = svs.ui.ReactIcon;
const _ReactRouterDOM = ReactRouterDOM,
  matchPath = _ReactRouterDOM.matchPath;
const IconButton = svs.ui.ReactIconButton;
setGlobal('svs.tur.navigationBack.logger', new svs.core.log.Logger('navigation-back'));

const NavigationBack = _ref => {
  let routes = _ref.routes,
    breadcrum = _ref.breadcrum,
    _ref$brand = _ref.brand,
    brand = _ref$brand === void 0 ? 'tur' : _ref$brand;
  let match;
  const _ReactRouterDOM$useLo = ReactRouterDOM.useLocation(),
    pathname = _ReactRouterDOM$useLo.pathname;
  const returnUrlParam = svs.utils.paramHandler.get({
    key: 'returnUrl'
  }).value;
  const returnUrl = returnUrlParam && decodeURIComponent(returnUrlParam);
  const findMatch = targetPath => {
    for (const path in routes) {
      const found = matchPath(targetPath, {
        path,
        exact: true
      });
      if (found) {
        return {
          path,
          route: routes[path]
        };
      }
    }
    return null;
  };

  const matchedReturnUrlRoute = returnUrl ? findMatch(returnUrl) : null;

  let matchedRoute = matchedReturnUrlRoute;
  if (!matchedRoute) {
    matchedRoute = findMatch(pathname);
  }
  if (matchedRoute) {
    match = matchedRoute.route;
    const displayText = matchedRoute.route.text;
    svs.tur.navigationBack.logger.debug("url match found for ".concat(matchedRoute.path, " display text ").concat(displayText ? "'".concat(displayText, "'") : 'NONE'));
  }
  if (!match) {
    svs.tur.navigationBack.logger.debug("no match found for ".concat(returnUrl ? returnUrl : pathname));
    return React.createElement(React.Fragment, null);
  }
  const backPath = typeof match.path === 'function' ? match.path() : match.path;
  const validatedReturnUrl = matchedReturnUrlRoute ? returnUrl : null;
  const handleOnClick = () => {
    if (typeof match.navigate === 'function') {
      match.navigate(validatedReturnUrl);
    } else {
      svs.utils.url.navigate(validatedReturnUrl || backPath);
    }
  };
  return React.createElement("div", {
    className: "padding-1 navigation-back-".concat(brand, " u-flex u-flex-align-items-center")
  }, React.createElement(IconButton, {
    className: "u-flex u-flex-align-items-center",
    "data-testid": "navigation-back-button",
    onClick: handleOnClick
  }, React.createElement(Icon, {
    icon: "menu-left",
    size: "200"
  }), match.text && React.createElement("span", {
    className: "margin-left-1 fc-navy f-500"
  }, match.text)), React.createElement("span", {
    className: "f-500 bold"
  }, breadcrum));
};
setGlobal('svs.tur.NavigationBack', NavigationBack);

 })(window);